"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Header_component_exports = {};
__export(Header_component_exports, {
  Header: () => Header
});
module.exports = __toCommonJS(Header_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_Cross = __toESM(require("@greatmindsorg/gmui-icons-lib/dist/Cross"));
var import_Button = require("../../Button/Button.component");
const Header = (_a) => {
  var _b = _a, {
    children,
    handleClose
  } = _b, props = __objRest(_b, [
    "children",
    "handleClose"
  ]);
  const CloseButton = () => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, { children: handleClose && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_Button.Button,
      {
        onPress: handleClose,
        variant: "tertiary",
        "aria-label": "Close Dialog",
        className: "gmui-dialog-svg-style",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Button.Button.Icon, { "aria-hidden": "true", children: handleClose && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Cross.default, { iconSize: "m", "aria-hidden": "true", title: "Close Dialog" }) })
      }
    ) });
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
    "div",
    {
      className: "box-border flex w-full bg-transparent",
      id: props.id,
      "data-testid": "headerContainer",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "flex grow items-center pb-10", "data-testid": "headerLeftContent", children: children && /* @__PURE__ */ (0, import_jsx_runtime.jsx)("h2", { id: "gmuiModalTitle", className: "gmui-font-style-h2 mt-0 flex", children }) }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "items-start", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CloseButton, {}) })
      ]
    }
  );
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Header
});
//# sourceMappingURL=Header.component.js.map